import minutesToMilliseconds from 'date-fns/minutesToMilliseconds';

import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { fetchProgram } from './queryFunctions';

type FetchProgramArgs = {
  id: string;
};

export function fetchProgramQuery({ id }: FetchProgramArgs) {
  return queryClient.fetchQuery({
    queryFn: () => fetchProgram({ id }),
    queryKey: queryKeys.program(id),
    staleTime: minutesToMilliseconds(10),
  });
}
